import { Component, OnInit, ElementRef, AfterViewInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FrontendRouteService } from '../frontend-route.service';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { PlantingSiteAreaDto } from '../../../models/trofaco/plantingSiteAreaDto';
import { VideoDto } from '../../../models/trofaco/videoDto';
import { BaseComponent } from '../../core/components/bases/base-component';
import { AgmMap } from '@agm/core';
import { PlantingSiteService } from '../../core/services/planting-site.service';
import { CsvDto } from 'src/app/models/trofaco/csvDto';

@Component({
    selector: 'app-video-detail-embeded',
    templateUrl: './video-detail-embeded.component.html',
    styleUrls: ['./video-detail-embeded.component.css'],
    providers: [FrontendRouteService]
})
export class VideoDetailEmbededComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('youTubePlayer', { static: true }) youTubePlayer: ElementRef<HTMLDivElement>;
    @ViewChild(AgmMap, { static: true }) map: AgmMap;

    pinUrl = '/assets/img/map-icons/photo-pin-s.png';
    focusedPinUrl = '/assets/img/map-icons/photo-pin-focus.png';

    availableIcon = 'assets/img/map-icons/map-m-green.png';
    notAvailableIcon = 'assets/img/map-icons/map-m-red.png';
    labelBar = 'assets/img/map-icons/bar-label.png'

    site: PlantingSiteDto;
    siteArea: PlantingSiteAreaDto;
    video: VideoDto;
    allFlightPath: CsvDto;
    videoWidth: number | undefined;
    videoHeight: number | undefined;
    youtubeId?: string;
    nowDate = new Date().getTime();

    readonly mapTypeId = 'hybrid';

    showInfo: boolean;
    showMap: boolean;
    showTimeline: boolean;
    showTree: boolean;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private frontendRoute: FrontendRouteService,
        private plantingSiteArea: PlantingSiteService,
    ) {
        super();
    }

    ngOnInit() {
        this.frontendRoute.currentSite$.subscribe(s => this.site = s);
        this.frontendRoute.currentPlantingSiteArea$.subscribe(c => this.siteArea = c);
        this.frontendRoute.currentVideo$.subscribe(v => this.video = v);

        this.showInfo = this.frontendRoute.showInfo$;
        this.showMap = this.frontendRoute.showMap$;
        this.showTimeline = this.frontendRoute.showTimeline$;
        this.showTree = this.frontendRoute.showTree$;

        this.getFlightPathData();
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }

    ngAfterViewInit(): void {
        this.onResize();
    }

    onResize = (): void => {
        this.videoWidth = this.youTubePlayer.nativeElement.clientWidth;
        this.videoHeight = this.youTubePlayer.nativeElement.clientHeight;
        this._changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.onResize);
    }

    public getYoutubeId(): string {
        const code = this.video.videoUrl.replace('https://www.youtube.com/watch?v=', '').replace('https://youtu.be/', '');
        return code;
    }

    async getFlightPathData() {
        const anyFlightPathFromThisSite = this.siteArea.id;
        await this.plantingSiteArea.getFlightPathData(anyFlightPathFromThisSite).then(
            (value) => {
                this.allFlightPath = value;
            }
        );
    }

}
